import React, { useEffect } from 'react'
import DateTime from '../DateTime'
import Icon from 'components/Icon'

const DraftFutureOrder = ({ attribute, state, onChange }) => {
  const { key, name, options, title} = attribute
  const { selected, startDate } = state || { selected: false, startDate: '' }

  useEffect(() => {
    if (attribute && !state) {
      onChange({ selected, startDate })
    }
  }, [attribute, state])

  const onClick = () => {
    if (options.includes(!selected)) {
      onChange({ ...state, selected: !selected })
    }
  }

  return (
    <fieldset className="space-y-2">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
            { name }
          </p>
          {title && (
            <Icon
              icon="info-circle"
              title={title}
              className="text-primary hover:text-secondary"
            />
          )}
        </div>

        <button type="button" className={`shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary`} aria-pressed="false" onClick={onClick}>
          <span aria-hidden="true" className="pointer-events-none absolute bg-white w-full h-full rounded-sm"></span>
          <span aria-hidden="true" className={`${selected ? 'bg-primary' : 'bg-gray-200'} pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200`}></span>
          <span aria-hidden="true" className={`${selected ? 'translate-x-5' : 'translate-x-0'} pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200`}></span>
        </button>
      </div>
      { selected &&
        <DateTime
          attribute={{name: 'Start date'}}
          state={startDate}
          onChange={(value) => onChange({ ...state, startDate: value })}
        />
      }
    </fieldset>
  )
}

export default DraftFutureOrder
